import { render } from "./InstagramTile.vue?vue&type=template&id=081615a7&scoped=true"
import script from "./InstagramTile.vue?vue&type=script&lang=js"
export * from "./InstagramTile.vue?vue&type=script&lang=js"

import "./InstagramTile.vue?vue&type=style&index=0&id=081615a7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081615a7"]])

export default __exports__